export const SUPPORT_EMAIL = 'privacy@johnsonjobs.com';

export const JOB_DETAILS_LOADER_TEXTS = [
  'Making sure this opportunity is still open for you — just a moment!',
  'Putting together the key details you need to apply confidently',
  'If this role has closed, we’ll suggest similar opportunities worth checking out',
];

export const PROFILE_LOADER_TEXTS = [
  'Transforming your experience into a compelling career narrative',
  'Finalizing your personalized career profile',
];

export const DEFAULT_LOADER_TEXTS = ['Fetching information', 'Preparing content'];

export const STUB_DEFAULT_TEXTS = {
  mainText: 'NO RESULTS',
  subText: 'We searched far and wide and couldn’t find any positions matching your search',
};
